import Storage from '../utilities/storage.js';

function Product ( productId, productType, description, price1, price2, r_Points, priceCadet, wcName = null) {

  this.productId = productId;
  this.productType = productType;
  this.description = description;
  this.price1 = price1;
  this.price2 = price2;
  this.r_Points = r_Points;
  this.priceCadet = priceCadet;
  this.wcName = wcName;

}

Product.prototype.getProductById = function ( productId, api ) {

  //if no id decalred just use object id
  if(!productId){
    let productId = this.productId;
  }

  return new Promise( function( resolve, reject ){
    //check local storage
    let storage = new Storage();
    let productStorage = storage.retrieve( 'products' );
    if ( productStorage ) {
      //check for id in storage
      if ( productStorage.items[productId] ){
        //if exists - check hasn't expired
        if( !storage.expired( productStorage.items[productId] ) ){
          let product = productStorage.items[productId];
          //set attributes
          this.productId = product.productId;
          this.productType = product.productType;
          this.description = product.description;
          this.price1 = product.price1;
          this.price2 = product.price2;
          this.r_Points = product.r_Points;
          this.priceCadet = product.priceCadet;
          //resolve if meets these criteria
          console.log('product fetched from storage');
          return resolve( productStorage.items[productId] )
        }
      }
    }
    //fetch if requried
    this.getProductFromApi( api )
      .then( product => {
        console.log('from api');
        storage.store( product.productId, 'products', product );
        resolve(product)
      })

  }.bind(this))
}

Product.prototype.getProductFromApi = function ( api ) {
  return new Promise( function( resolve, reject ){

    let productQueryString = api.base_url + 'products/' + this.productId + '?key=' + api.api;
    fetch( productQueryString )
      .then( response => api.checkResponse(response) )
      .then( response => api.returnJson(response) )
      .then( result => {
        let product = result.products[0]; //products returns as products object

        this.productId = product.productId;
        this.productType = product.productType;
        this.description = product.description;
        this.price1 = product.price1;
        this.price2 = product.price2;
        this.r_Points = product.r_Points;
        this.priceCadet = product.priceCadet;
        resolve( product )
      })
      .catch( err => {
        reject( err );
      })

  }.bind(this))
}

export default Product;
